import { get } from 'lodash';

export const parcels = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_PARCELS': {
      const newParcels = get(action, 'payload.parcels', []);

      if (!Array.isArray(newParcels)) {
        const newState = { ...state };

        Object.entries(newParcels).forEach(([id, parcel]) => {
          newState[id] = {
            type: 'Feature',
            properties: {
              ...get(newState[id], 'properties', {}),
              ...get(parcel, 'properties', {}),
            },
            geometry: {
              ...get(newState[id], 'geometry', {}),
              [parcel.geometry.type]: parcel.geometry,
            },
          };
        });
        return newState;
      }

      return newParcels.reduce(
        (newState, parcel) => {
          /* eslint-disable-next-line no-param-reassign */
          newState[
            parcel[action.payload.identifierKey || 'parcel_id'] ||
              parcel.properties[action.payload.identifierKey || 'parcel_id']
          ] = parcel;
          return newState;
        },
        { ...state },
      );
    }
    default:
      return state;
  }
};
